<template>
  <div class="payment-fiscal-step">
    <box type="primary" :title="t('Configuração fiscal')" data-testid="subaccounts-fiscal-step-notice">
      <p>{{ t('A configuração fiscal (NFS-e / DTE) é feita na tela dedicada, por franquia.') }}</p>
      <Button
        :label="t('Abrir Configuração Fiscal')"
        data-testid="subaccounts-fiscal-open-canonical-btn"
        @click="openCanonical" />
    </box>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { log } from '@/utils/DebugLogger';
import { eventBus } from '@/eventBus';

type Id = number | string;

interface Props {
  accountId?: Id | null;
}

withDefaults(defineProps<Props>(), {
  accountId: null
});

const emit = defineEmits<{
  validate: [isValid: boolean];
}>();

const { t } = useI18n();
const router = useRouter();

// Methods
const openCanonical = (): void => {
  log('FranchisesFiscalStep', 'openCanonical', 'Navigating to the canonical fiscal config screen');
  eventBus.emit('modal.franchisessubaccount.wizard.close');
  router.push('/subaccounts/fiscal-config');
};

// Lifecycle
onMounted(() => {
  log('FranchisesFiscalStep', 'onMounted', 'Component mounted (pointer panel)');
  emit('validate', true);
});
</script>

<style scoped>
.payment-fiscal-step {
  min-height: 120px;
}
</style>
